<!-- 图片组件 -->
<template>
  <img class="posterArea" :src="imageUrl" @click="handleClick" />
</template>
<script>
import handleRedirect from '../mixins/pureHandleRedirect';

export default {
  mixins: [handleRedirect],
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t ? this.$t('track.base_comp_img') : '图片'
    });
  },
  methods: {
    handleClick() {
      this.handleRedirect();
    }
  }
};
</script>

<style lang="less" scoped>
.posterArea {
  margin: 0 auto;
  width: 100%;
}
</style>
